import { render, staticRenderFns } from "./ApplicationOrganizationTransfer.vue?vue&type=template&id=3f961634&scoped=true&"
import script from "./ApplicationOrganizationTransfer.vue?vue&type=script&lang=js&"
export * from "./ApplicationOrganizationTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f961634",
  null
  
)

export default component.exports